import React from 'react'
import { useMediaQuery } from '@mui/material'

import { layoutCompactDialogMediaQuery } from '../../../../layout/layoutConstants'
import { getRefundConfirmApproveLabel } from '../../helpers/refundApprovalDialogHelpers'

const RefundApprovalConfirmButtonLabel = () => {
  const compactDialog = useMediaQuery(layoutCompactDialogMediaQuery, { noSsr: true })

  return getRefundConfirmApproveLabel(compactDialog)
}

export default RefundApprovalConfirmButtonLabel
